export default function numberNullSafety(number) {
  return number > 0 ? number : 0
}
